// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallsDateTimeField__container-eba312 {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ScheduledCallsDateTimeField__content-efdac7 {
  flex: 1;
  padding: 24px;
  overflow: auto;
}

.ScheduledCallsDateTimeField__label-f8adf1 {
  flex: 1;
  padding-top: 14px;
  margin-inline-end: 16px;
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.ScheduledCallsDateTimeField__dateTime-aa1a5b {
  display: flex;
  flex-direction: row;
  position: relative;
}

.ScheduledCallsDateTimeField__date-fbf715 {
  width: 160px;
  margin-inline-end: 16px;
  cursor: pointer;
}

.ScheduledCallsDateTimeField__date-fbf715 * {
  cursor: pointer;
}

.ScheduledCallsDateTimeField__error-text-f0c0e4 {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  margin-top: 4px;
  padding: 0 12px;
  color: var(--danger-40);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduledCalls/components/ScheduledCallsForm/ScheduledCallsDateTimeField/ScheduledCallsDateTimeField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,OAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.content {\n  flex: 1;\n  padding: 24px;\n  overflow: auto;\n}\n\n.label {\n  flex: 1;\n  padding-top: 14px;\n  margin-inline-end: 16px;\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.dateTime {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n}\n\n.date {\n  width: 160px;\n  margin-inline-end: 16px;\n  cursor: pointer;\n}\n\n.date * {\n  cursor: pointer;\n}\n\n.error-text {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  margin-top: 4px;\n  padding: 0 12px;\n  color: var(--danger-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduledCallsDateTimeField__container-eba312`,
	"content": `ScheduledCallsDateTimeField__content-efdac7`,
	"label": `ScheduledCallsDateTimeField__label-f8adf1`,
	"dateTime": `ScheduledCallsDateTimeField__dateTime-aa1a5b`,
	"date": `ScheduledCallsDateTimeField__date-fbf715`,
	"error-text": `ScheduledCallsDateTimeField__error-text-f0c0e4`,
	"errorText": `ScheduledCallsDateTimeField__error-text-f0c0e4`
};
module.exports = ___CSS_LOADER_EXPORT___;
